import { Modal } from '@design';
import { appPaths } from '@terminal/routes/app-paths';
import { queryKeys } from '@terminal/routes/query-params';
import { useWatchlistManagerWidget } from '@terminal/stores/use-watchlist-manager-widget/useWatchlistManagerWidget';
import { useOnboardingStore } from '@terminal/views/onboarding/hooks/useOnboardingStore';
import { WatchlistManagerWidget } from '@terminal/widgets/watchlist-manager-widget/WatchlistManagerWidget';
import React, { useEffect } from 'react';
import { useMatch, useNavigate, useSearchParams } from 'react-router';

import styles from './WatchlistManagerModal.module.scss';

export const WatchlistManagerModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const isOnWatchlistRoute = useMatch(`${appPaths.watchlist}/*`);

  const clearStore = useOnboardingStore(state => state.clearStore);
  const {
    setIsAddMode,
    setIsEditMode,
    setOnConfirmCallback,
    setShouldResetList,
  } = useWatchlistManagerWidget(state => ({
    setIsAddMode: state.setIsAddMode,
    setIsEditMode: state.setIsEditMode,
    setOnConfirmCallback: state.setOnConfirmCallback,
    setShouldResetList: state.setShouldResetList,
  }));

  const onClose = () => {
    searchParams.delete(queryKeys.widget);
    searchParams.delete(queryKeys.watchlistId);
    setSearchParams(searchParams);
  };

  const onListCreated = (id: string) => {
    if (isOnWatchlistRoute) {
      navigate(`${appPaths.watchlist}/${id}`);
    } else {
      onClose();
    }
  };

  useEffect(() => {
    return () => {
      setIsAddMode();
      setIsEditMode();
      setOnConfirmCallback();
      setShouldResetList();
      clearStore();
    };
  }, []);

  return (
    <Modal
      className={styles.styledModal}
      data-testid="watchlist-manager-modal"
      isOpen
      onClose={onClose}
    >
      <WatchlistManagerWidget
        onListCreated={onListCreated}
        onCancel={onClose}
      />
    </Modal>
  );
};
